// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context{
    font-family: Arial, sans-serif;
    margin: 0;
    margin-top: 10%;
    padding: 0;
}

.contextTitle{
    font-size: 25px;
    font-weight: bolder;
}

.titleSeparator {
    max-width: 30%;
    border: none; /* 기본 테두리 제거 */
    height: 2px; /* 선의 두께 */
    background-color: #a7c898; /* 선의 색상 */
    margin-top: 15px; /* 제목과 선 사이의 여백 */
}
.proceeding-container{
    max-width: 30%;
    align-content: center;
    justify-content: center;
    padding-left: 35%;
    padding-top: 50px;
    padding-bottom: 100px;
}

.proceeding-container li{
    margin: 30px;
    text-decoration: none;
    background-color: #282c34;
    border-radius: 6px;
    list-style-type: none;
    padding: 30px;
    margin-bottom: 50px;
}

.proceeding-container li:hover{
   background-color: #e8e8e8;
    a {
        color: #282c34;
    }
}
.proceeding-container a{
    text-decoration: none;
    color:#e8e8e8;
}



`, "",{"version":3,"sources":["webpack://./src/pages/Proceeding/styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY,EAAE,cAAc;IAC5B,WAAW,EAAE,UAAU;IACvB,yBAAyB,EAAE,UAAU;IACrC,gBAAgB,EAAE,iBAAiB;AACvC;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;GACG,yBAAyB;IACxB;QACI,cAAc;IAClB;AACJ;AACA;IACI,qBAAqB;IACrB,aAAa;AACjB","sourcesContent":[".context{\n    font-family: Arial, sans-serif;\n    margin: 0;\n    margin-top: 10%;\n    padding: 0;\n}\n\n.contextTitle{\n    font-size: 25px;\n    font-weight: bolder;\n}\n\n.titleSeparator {\n    max-width: 30%;\n    border: none; /* 기본 테두리 제거 */\n    height: 2px; /* 선의 두께 */\n    background-color: #a7c898; /* 선의 색상 */\n    margin-top: 15px; /* 제목과 선 사이의 여백 */\n}\n.proceeding-container{\n    max-width: 30%;\n    align-content: center;\n    justify-content: center;\n    padding-left: 35%;\n    padding-top: 50px;\n    padding-bottom: 100px;\n}\n\n.proceeding-container li{\n    margin: 30px;\n    text-decoration: none;\n    background-color: #282c34;\n    border-radius: 6px;\n    list-style-type: none;\n    padding: 30px;\n    margin-bottom: 50px;\n}\n\n.proceeding-container li:hover{\n   background-color: #e8e8e8;\n    a {\n        color: #282c34;\n    }\n}\n.proceeding-container a{\n    text-decoration: none;\n    color:#e8e8e8;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
